import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useLang } from "../i18n";

export default function ScrollToTop() {
  const { pathname } = useLocation();
  const { t, lang } = useLang();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    if (pathname.startsWith("/collezione/")) return; // DressDetail sets the dress title
    document.title =
      pathname === "/" ? t("seo.title.home") :
      pathname === "/atelier" ? t("seo.title.atelier") :
      pathname === "/collezione" ? t("seo.title.collezione") :
      pathname === "/noleggio" ? t("seo.title.noleggio") :
      pathname === "/appuntamenti" ? t("seo.title.appuntamenti") : "Per Lei Bridal";
  }, [pathname, lang]);
  return null;
}
